/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 *
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


import { ToastService } from './toast/toast.service';
import { ToastComponent } from './toast/toast.component';
import { ConfirmDialogService } from './configrm-dialog/confirm-dialog.service';
import { ConfirmDialogComponent } from './configrm-dialog/confirn-dialog.component';

@NgModule({
    declarations: [ToastComponent, ConfirmDialogComponent],
    imports: [
        CommonModule, RouterModule
    ],
    exports: [
       ToastComponent, ConfirmDialogComponent
    ],
    providers: [
        ToastService,
        ConfirmDialogService
    ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// ./src/layout/layout.module.ts